import { formatFileSize } from './utils';
import { ValidationMessageTemplate } from '@vee-validate/i18n';
import moment from 'moment';

const messages: Record<string, ValidationMessageTemplate> = {
  _default: (field) => `${field.label} er ikke gyldig.`,
  after: (field) => `${field.label} skal være efter ${field.rule?.params}.`,
  alpha_dash: (field) =>
    `${field.label} må kun indeholde tal, bogstaver, bindestreger og underscores.`,
  alpha_num: (field) => `${field.label} må kun indeholde tal og bogstaver.`,
  alpha_spaces: (field) => `${field.label} må kun indeholde bogstaver og mellemrum.`,
  alpha: (field) => `${field.label} må kun indeholde bogstaver.`,
  before: (field) => `${field.label} skal være før $${field.rule?.params}.`,
  between: (field) =>
    `${field.label} skal være mellem ${field.rule?.params} og ${field.rule?.params}.`, // TODO
  confirmed: (field) => `${field.label} skal matche ${field.rule?.params}.`, // TODO
  date_between: (field) =>
    `${field.label} skal være mellem ${field.rule?.params} og ${field.rule?.params}.`,
  date_format: (field) => `${field.label} skal være i formatet: ${field.rule?.params}.`,
  decimal: (field : any, [places = '*', separator = ','] = []) =>
    `${field.label} skal være numerisk og må maksimalt indeholde ${ field?.rule?.params[0]} decimaler.`,
  digits: (field) => `${field.label} skal være et tal på ${field.rule?.params} cifre.`,
  dimensions: (field) =>
    `${field.label} skal være ${field.rule?.params} pixels gange ${field.rule?.params} pixels.`, // TODO
  email: (field) => `${field.label} skal være en gyldig email.`,
  ext: (field) => `${field.label} skal være en gyldig filtype.`,
  image: (field) => `${field.label} skal være et billede.`,
  in: (field) => `${field.label} skal være en gyldig værdi.`,
  ip: (field) => `${field.label} skal være en gyldig ip-adresse.`,
  max: (field) => `${field.label} må maksimalt være ${field.rule?.params} karakterer.`,
  max_value: (field) => `${field.label} må maximum være ${field.rule?.params}.`,
  mimes: (field) => `${field.label} skal være en gyldig filtype.`,
  min: (field) => `${field.label} skal minimum være ${field.rule?.params} karakterer.`,
  min_value: (field) => `${field.label} skal minimum være ${field.rule?.params}.`,
  not_in: (field) => `${field.label} skal være en gyldig værdi.`,
  numeric: (field) => `${field.label} skal være numerisk.`,
  regex: (field) => `${field.label} skal have et gyldigt format.`,
  required: (field) => `${field.label} skal udfyldes.`,
  custom_required: (field) => `${field.label} skal udfyldes.`,
  size: (field) => `${field.label} må maksimalt have en størrelse på ${formatFileSize('TODO')}.`,
  url: (field) => `${field.label} skal være en gyldig URL.`,
  mod11: (field) => `${field.label} skal være gyldigt.`,
  cpr_number: (field) => `${field.label} skal indeholde 6 + 4 cifre.`,
  cpr_number_field: (field) => `${field.label} skal indeholde 10 cifre.`,
  letters_numbers: (field) => `${field.label} må kun indeholde tal, bogstaver og bindestreg.`,

  // Custom rules
  selected_date_before_claim_event_date: (field) =>
    `Du kan ikke vælge et tidspunkt efter ${field.rule?.params}.`,
  file_bundle_size: (field) =>
    `Den samlede filstørrelse er for stor og må max. være ${formatFileSize(
      field?.rule?.params as any
    )} for alle vedhæftede filer.`,
  file_already_selected: (field) => `Du må ikke vælge den samme fil to gange i ${field.label}.`,
  file_size_exists: () =>
    'En eller flere af de filer, du har vedhæftet, har ikke noget indhold – tjek gerne, om du har vedhæftet den rigtige fil.',
  valid_date_range: (field: any) =>
    `${field.label} skal være mellem ${moment(field.rule.params[0]).format((window as any)?.dateFormat )} og ${moment(field.rule.params[1]!).format((window as any)?.dateFormat)}.`,
  min_date: (field) => `${field.label} skal være efter ${field.rule?.params}.`,
  max_date: (field) => `${field.label} skal være inden ${field.rule?.params}.`,
  license_plate_exists: () => `Registreringsnummer kunne ikke findes`
};

export default messages;
